/* @flow */
import AdminAutoMessageSftpCredentials from './AdminAutoMessageSftpCredentials.jsx';

export { AdminAutoMessageSftpCredentials };
